import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_ZIP, DELETE_ZIP, UPDATE_ZIP_STATUS, GET_STATES, EDIT_ZIP, ADD_ZIP, IMPORT_ZIP_DATA } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetZipSuccess, GetZipFailure, DeleteZipSuccess, DeleteZipFailure, UpdateZipStatusSuccess, UpdateZipStatusFailure, GetStatesSuccess, GetStatesFailure, AddZipSuccess, AddZipFailure, EditZipSuccess, EditZipFailure, ImportDataSuccess, ImportDataFailure } from "../Actions/ZipAction";

function* GetZipRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/zipcodes?status=${actions.payload.status}&sort_by=${actions.payload.sort_by}&sort_type=${actions.payload.sort_type}&search_key=${actions.payload.search_key}&page=${actions.payload.page}`, {
      headers: defaultHeaders(),
    });
    if (res.status === 200) {
      yield put(GetZipSuccess(res.data));
    } else {
      yield put(GetZipFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetZipFailure(e));
  }
}

function* DeleteZipRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/zipcode/${actions.payload}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(DeleteZipSuccess(res.data));
    } else {
      yield put(DeleteZipFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteZipFailure(e));
  }
}

function* zipStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    zip_code_status: actions.payload.status,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_zipcode_status`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(UpdateZipStatusSuccess(res.data));
    } else yield put(UpdateZipStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateZipStatusFailure(e));
  }
}

function* GetStatesRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/states`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });
    if (res.status === 200) {
      yield put(GetStatesSuccess(res.data));
    } else {
      yield put(GetStatesFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetStatesFailure(e));
  }
}

function* addZipRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    zip_code: actions.payload.zip_code,
    state: actions.payload.state,
    city: actions.payload.city,
    service_start_time: actions.payload.service_start_time,
    service_end_time: actions.payload.service_end_time,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_zipcode`, getFormData(body), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddZipSuccess(res.data));
    } else yield put(AddZipFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddZipFailure(e));
  }
}

function* editZipRequest(actions) {
  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }
  const body = {
    zip_code: actions.payload.zip_code,
    state: actions.payload.state,
    city: actions.payload.city,
    service_start_time: actions.payload.service_start_time,
    service_end_time: actions.payload.service_end_time,
    id: actions.payload.id,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_zipcode`, getFormData(body), { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(EditZipSuccess(res.data));
    } else yield put(EditZipFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditZipFailure(e));
  }
}

function* ImportDataRequest(actions) {
  let data = [];
  actions &&
    actions.payload &&
    actions.payload.map((arr) => {
      data.push(arr);
    });
  const body = {
    data,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/import_zipcode_data`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(ImportDataSuccess(res.data));
    } else {
      yield put(ImportDataFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ImportDataFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_ZIP, GetZipRequest);
  yield takeLatest(DELETE_ZIP, DeleteZipRequest);
  yield takeLatest(UPDATE_ZIP_STATUS, zipStatusRequest);
  yield takeLatest(GET_STATES, GetStatesRequest);
  yield takeLatest(ADD_ZIP, addZipRequest);
  yield takeLatest(EDIT_ZIP, editZipRequest);
  yield takeLatest(IMPORT_ZIP_DATA, ImportDataRequest);
}

export default function* ZipSaga() {
  yield all([actionWatcher()]);
}
